import {useMemo} from "react";
import type {MaybeNil} from "app/utils/types";
import {isNil} from "app/utils/stdlib";
import {ComboBox, type ComboBoxProps} from "app/employee/controlCard/ComboBox";

export interface IdComboBoxProps<Option, Id> extends Omit<ComboBoxProps<Option>, "value"> {
  value?: MaybeNil<Id[]>;
  isEqual: (option: Option, value: Id) => boolean;
}

export const IdComboBox = <Option, Id>({options, value, isEqual, ...rest}: IdComboBoxProps<Option, Id>) => {
  const selectedOptions = useMemo(() => {
    const selectedOptions: Option[] = [];
    if (!isNil(options) && !isNil(value)) {
      for (const option of options) {
        if (value.some((v) => isEqual(option, v))) {
          selectedOptions.push(option);
        }
      }
    }
    return selectedOptions;
  }, [isEqual, options, value]);

  return <ComboBox {...rest} options={options} value={selectedOptions} />;
};
